import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { InfoOption } from '@app/forms/subscription/components/info/info.component';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { infoOption } from '@app/forms/subscription/services/ref';

@Component({
    selector: 'money-games',
    templateUrl: './money-games.component.html',
    styleUrls: ['./money-games.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class MoneyGamesComponent implements OnInit {
  @Input() derrors = false;
  optionInfo1: InfoOption = infoOption;
  options: FormControlOption[] = [
    {
      value: 'NEVER',
      label: 'Jamais',
      suffix: { title: 'A' },
    },
    {
      value: 'OCCASIONALLY',
      label: "À l'occasion",
      suffix: { title: 'B' },
    },
    {
      value: 'FREQUENTLY',
      label: 'Fréquemment',
      suffix: { title: 'C' },
    },
  ];
  constructor(private controlContainer: FormGroupDirective) {}
  get form() {
    return this.controlContainer.form;
  }

  ngOnInit() {}
}
